import { tv } from "tailwind-variants";

import { mainSectionsPaddings } from "@/common/constants";

export const getPackagesCarouselSectionClass = tv({ base: [mainSectionsPaddings, "lg:-my-4 lg:pt-0"] });

export const getArrowsClass = tv({
  base: [
    "scale-125 border-primary-500 bg-primary-500 text-white max-lg:hidden",
    "hover:border-secondary-500 hover:bg-secondary-500",
  ],
});
